import { assetClassAnalysisPages } from "@app/const/route.const";
import { AssetClassAnalysisAnalyze } from "./AssetClassAnalysisAnalyze";
import { AssetClassAnalysisDashboard } from "./AssetClassAnalysisDashboard";
import { AccessRouteControl } from "@app/components/AccessRouteControl";
import { CarModuleSectionCode } from "@app/hooks/useUserAccess";
import { PdfDistanceFromTrendReportPage } from "@app/pages/assetClassAnalysis/pdfDistanceFromTrendReport/PdfDistanceFromTrendReportPage";
import { PdfPerformanceRiskReportPage } from "./pdfPerformanceRiskReport/PdfPerformanceRiskReportPage";
import { PdfSimulatedForwardProbabilitiesReportPage } from "./pdfSimulatedForwardProbabilitiesReportPage/PdfSimulatedForwardProbabilitiesReportPage";
import { PdfMultiPeriodReturnReportPage } from "./pdfMultiPeriodReturnReport/PdfMultiPeriodReturnReportPage";
import { PdfSectorAnalysisReportPage } from "./pdfSectorAnalysisReport/PdfSectorAnalysisReportPage";
import { PdfSummaryReportPage } from "./pdfSummaryReport/PdfSummaryReportPage";
import { PdfIndexCompareReportPage } from "./pdfIndexCompareReport/PdfIndexCompareReportPage";

export const AssetClassAnalysisPage = () => {
  return (
    <AccessRouteControl
      items={[
        {
          path: assetClassAnalysisPages.dashboard,
          element: <AssetClassAnalysisDashboard />,
          moduleSection: CarModuleSectionCode.ASSET_CLASS_ANALYSIS_DASHBOARD,
        },
        {
          path: assetClassAnalysisPages.analyzePath,
          element: <AssetClassAnalysisAnalyze />,
          moduleSection: CarModuleSectionCode.ASSET_CLASS_ANALYSIS_ANALYZE,
        },
        {
          path: assetClassAnalysisPages.pdfSummaryReportPath,
          element: <PdfSummaryReportPage />,
          moduleSection: CarModuleSectionCode.PDF_SUMMARY_REPORT,
        },
        {
          path: assetClassAnalysisPages.pdfPerformanceRiskReportPath,
          element: <PdfPerformanceRiskReportPage />,
          moduleSection: CarModuleSectionCode.PDF_PERFORMANCE_RISK_REPORT,
        },
        {
          path: assetClassAnalysisPages.pdfMultiPeriodReturnReportPath,
          element: <PdfMultiPeriodReturnReportPage />,
          moduleSection: CarModuleSectionCode.PDF_MULTI_PERIOD_RETURN_REPORT,
        },
        {
          path: assetClassAnalysisPages.pdfDistanceFromTrendReportPath,
          element: <PdfDistanceFromTrendReportPage />,
          moduleSection: CarModuleSectionCode.PDF_DISTANCE_FROM_TREND_REPORT,
        },
        {
          path: assetClassAnalysisPages.pdfSectorAnalysisReportPath,
          element: <PdfSectorAnalysisReportPage />,
          moduleSection: CarModuleSectionCode.PDF_SECTOR_ANALYSIS_REPORT,
        },
        {
          path: assetClassAnalysisPages.pdfSimulatedForwardProbabilitiesReportPath,
          element: <PdfSimulatedForwardProbabilitiesReportPage />,
          moduleSection:
            CarModuleSectionCode.PDF_SIMULATED_FORWARD_PROBABILITY_REPORT,
        },
        {
          path: assetClassAnalysisPages.pdfIndexCompareReportPath,
          element: <PdfIndexCompareReportPage />,
          moduleSection: CarModuleSectionCode.PDF_INDEX_COMPARE_REPORT,
        },
      ]}
      defaultPath={assetClassAnalysisPages.dashboard}
    />
  );
};
